import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-furnitureshop-reward.js';

const laurelLeft = 'https://cdn.skyfastimg.com/images/2026/08/21/image-6a87facfe564c716651e5769.png?w=500';
const laurelRight = 'https://cdn.skyfastimg.com/images/2026/08/21/image-6a87fadca28f9b4016353e5e.png?w=500';

const awardHtml = (attribute, content) => `
  <div class="furnitureshop-reward__award">
    <img class="furnitureshop-reward__laurel" src="${laurelLeft}" alt="" />
    <div class="furnitureshop-reward__award-content" data-attribute="${attribute}">
      ${content}
    </div>
    <img class="furnitureshop-reward__laurel" src="${laurelRight}" alt="" />
  </div>
`;

const backgroundImage = 'https://cdn.skyfastimg.com/images/2026/08/21/image-6a87faf05b322e4c4a8ba22b.webp?w=1000';
const backgroundImageMobile = 'https://cdn.skyfastimg.com/images/2026/08/21/image-6a87fafc76057a4617f4363b.webp?w=1000';

const contentHtml = `
  <div class="container">
    <div
      class="furnitureshop-reward"
      data-attribute="furnitureshop-reward"
      data-background-image="${backgroundImage}"
      data-background-image-mobile="${backgroundImageMobile}"
      style="background-image: url(${backgroundImage}); --furnitureshop-reward-background-mobile: url(${backgroundImageMobile});"
    >
      <div class="furnitureshop-reward__content" data-attribute="furnitureshop-reward__content">
        <h2><strong>Pro Detailers' Choice</strong></h2>
        <p>
          We engineer smarter, stronger surfaces-delivering industry-leading
          performance, effortless use, and lasting durability to keep your vehi-cle's finish flawless
        </p>
      </div>
      <div class="furnitureshop-reward__awards" data-attribute="furnitureshop-reward__awards">
        ${awardHtml('furnitureshop-reward__innovation', '<h2><strong>TOP.1</strong></h2><p>Innovation</p>')}
        ${awardHtml('furnitureshop-reward__tiktok-hot', '<h2><strong>TOP.1</strong></h2><p>TikTok Hot</p>')}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#010101',
  textColor: '#1b1b1b',
  topPadding: true,
  bottomPadding: true,
});
